<template>
	<div class="service-function-list">
		<!-- 服务周期 -->
		<!-- v-if="typeLists.system" -->
		<el-row type="flex" class="system">
			<el-col :span="1"> </el-col>
			<el-col :span="3" class="title">{{ '服务周期' }}</el-col>
			<el-col :span="8">
				<sky-progress
					:value="secondaryListData.expirationRate || 0"
					:startDate="secondaryListData.formatUpLineDate"
					:endDate="secondaryListData.formatExpirationTime"
					:attribute="{
						'stroke-width': 14,
						'text-inside': true,
					}"
				></sky-progress>
			</el-col>
			<el-col :span="2">剩余时间 {{ secondaryListData.remainingDay }} 天</el-col>
			<el-col :span="3">
				<el-tooltip effect="dark" placement="top-start" :content="secondaryListData.tgDomain">
					<div class="uniline">域名：{{ secondaryListData.tgDomain }}</div>
				</el-tooltip>
			</el-col>
			<el-col :span="3">
				系统账号
				{{ `${secondaryListData.haveSystemFunctionNum} / ${secondaryListData.systemFunctionNum}` }}
			</el-col>
			<el-col :span="4">
				<el-button type="text" @click="systemDialog = true">配置</el-button>
			</el-col>
		</el-row>

		<!-- 外贸智能云建站 -->
		<el-row type="flex" class="website">
			<el-col :span="1">
				<el-tooltip effect="dark" content="服务中" placement="top-start" v-if="serviceStatus.site">
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">{{ '外贸智能云建站' }}</el-col>
			<el-col :span="4" v-if="serviceStatus.site">
				<div>任务：{{ secondaryListData.serviceSite.flowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('serviceSite')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.serviceSite.staffVO &&
								secondaryListData.serviceSite.staffVO.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.site">
				<popover-text
					:line="1"
					:text="`主域名：${secondaryListData.serviceSite.domain || '-'}`"
					:subText="secondaryListData.serviceSite.domain || '-'"
				>
				</popover-text>
				<div class="language">
					<span>语种上线 ({{ languageOnline }})：</span>
					<el-tag
						size="mini"
						:type="item.status == 6 ? 'success' : 'info'"
						v-for="item in secondaryListData.serviceSite.languageList"
						:key="item.name"
						class="language-item"
						>{{ item.name }}</el-tag
					>
				</div>
			</el-col>
			<el-col :span="2" v-if="serviceStatus.site">
				<div style="color: #67c23a" v-if="secondaryListData.serviceSite.upLineStatus == 1">
					已上线
				</div>
				<div style="color: #f56c6c" v-if="secondaryListData.serviceSite.upLineStatus == 2">
					已下线
				</div>
				<div style="color: #b1b1b1" v-if="secondaryListData.serviceSite.upLineStatus == 0">
					未上线
				</div>
			</el-col>
			<el-col :span="3" v-if="serviceStatus.site">
				<div>域名到期：{{ secondaryListData.serviceSite.domainExpirationTime }}</div>
				<div>证书到期：{{ secondaryListData.serviceSite.sslDueTime }}</div>
			</el-col>
			<el-col :span="3" v-if="serviceStatus.site">
				<!-- <div>
          监测ID：{{ secondaryListData.accessData }}（{{
						accessType(secondaryListData.accessType)
					}}）
        </div> -->
				<el-tooltip
					effect="dark"
					:content="`${secondaryListData.serviceSite.inquiryEmail}（${emailType(
						secondaryListData.serviceSite.qyEmailType
					)}）`"
					placement="top-start"
					:disabled="
						!(
							secondaryListData.serviceSite.inquiryEmail &&
							secondaryListData.serviceSite.qyEmailType
						)
					"
				>
					<div class="uniline">
						询盘邮箱：{{ secondaryListData.serviceSite.inquiryEmail }}（{{
							emailType(secondaryListData.serviceSite.qyEmailType)
						}}）
					</div>
				</el-tooltip>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.site">
				<el-button type="text" @click="webDialog = true">配置</el-button>
				<el-button type="text" @click="serviceEdit('Site')">服务编辑</el-button>
			</el-col>
		</el-row>

		<!-- 谷歌广告管理 -->
		<el-row type="flex" class="google">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.google"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">{{ 'Google广告管理' }}</el-col>
			<el-col :span="4" v-if="serviceStatus.google">
				<div>任务：{{ secondaryListData.serviceGoogle.flowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('serviceGoogle')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.serviceGoogle.staffVO &&
								secondaryListData.serviceGoogle.staffVO.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.google"
				>CID：{{ secondaryListData.serviceGoogle.cidAccountVal }}</el-col
			>
			<el-col :span="8" v-if="serviceStatus.google">
				<div>小语种广告：{{ secondaryListData.serviceGoogle.languageName }}</div>
				<div>小语种优化师：{{ secondaryListData.serviceGoogle.languageServiceStaffName }}</div>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.google">
				<el-button type="text" @click="serviceEdit('Google')">服务编辑</el-button>
			</el-col>
		</el-row>

		<!-- SNS跨平台云社交 -->
		<el-row type="flex" class="SMOperation">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.operations"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">{{ 'SNS跨平台云社交' }}</el-col>
			<el-col :span="4" v-if="serviceStatus.operations">
				<div>任务：{{ secondaryListData.serviceSns.flowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('serviceSns')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.serviceSns.staffVO &&
								secondaryListData.serviceSns.staffVO.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>
			<el-col :span="12" v-if="serviceStatus.operations">
				<div>
					主页地址：<span style="color: #409eff">{{ secondaryListData.serviceSns.pageName }}</span>
				</div>
				<!-- <div class="platform" v-for="item in secondaryListData.platformList" :key="item.pageId">
					<el-col class="platform-item" :span="8">平台：{{ platform(item.businessCode) }}</el-col>
					<el-tooltip
						effect="dark"
						:content="'单月应发' + (item.taskCount || '-') + '条'"
						placement="top-start"
						:disabled="!item.pageName"
					>
						<el-col class="platform-item home-page uniline" :span="8"
							>单月应发{{ item.taskCount }}条</el-col
						>
					</el-tooltip>
					<el-col class="platform-item" :span="8">到期时间：{{ item.formatExpirationTime }}</el-col>
				</div> -->
			</el-col>
			<el-col :span="4" v-if="serviceStatus.operations">
				<el-button type="text" @click="serviceEdit('MediaOperation')">服务编辑</el-button>
				<el-button
					type="text"
					style="color: #f56c6c"
					@click="startService"
					v-if="secondaryListData.showStart == true && showStartServiceButton"
					>开始服务</el-button
				>
			</el-col>
		</el-row>

		<!-- Facebook广告管理 -->
		<el-row type="flex" class="facebook">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.facebook"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">{{ 'Facebook广告管理' }}</el-col>
			<el-col :span="4" v-if="serviceStatus.facebook">
				<div>任务：{{ secondaryListData.serviceFacebook.flowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('serviceFacebook')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.serviceFacebook &&
								secondaryListData.serviceFacebook.staffVO.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>
			<!-- <el-col :span="4">
				<el-tooltip effect="dark" :content="homePageName" placement="top-start">
					<div class="home-page uniline">主页名称：{{ homePageName }}</div>
				</el-tooltip>
			</el-col> -->
			<el-col :span="12" v-if="serviceStatus.facebook"
				>FBID：{{ secondaryListData.serviceFacebook.cidAccountVal }}</el-col
			>
			<!-- <el-col :span="4">主页ID：{{ pageId }}</el-col> -->
			<el-col :span="4" v-if="serviceStatus.facebook">
				<el-button type="text" @click="serviceEdit('Facebook')">服务编辑</el-button>
			</el-col>
		</el-row>

		<!-- 智能网站访客识别 -->
		<el-row type="flex" class="email-marketing">
			<el-col :span="1">
				<el-tooltip effect="dark" content="服务中" placement="top-start" v-if="serviceStatus.znss">
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">智能网站访客识别</el-col>
			<el-col :span="4" v-if="serviceStatus.znss">
				<div>任务：{{ secondaryListData.serviceVisitorsToIdentify.flowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('serviceVisitorsToIdentify')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.serviceVisitorsToIdentify.staffVO &&
								secondaryListData.serviceVisitorsToIdentify.staffVO.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>

			<el-col
				:span="4"
				v-if="serviceStatus.znss && secondaryListData.serviceVisitorsToIdentify.visitorNum != null"
				>本月数据:{{ secondaryListData.serviceVisitorsToIdentify.visitorNum }}/{{
					secondaryListData.serviceVisitorsToIdentify.monthNum
				}}(已识别/月识别)

				<!-- <el-popover placement="top-end" width="200" trigger="hover" @show="show">
					<p v-for="(item, index) in visitorList" :key="index" class="monthNum">
						<span>{{ item.monthStr }}</span
						><span>{{ item.visitorNum }}/{{ item.monthNum }}</span>
					</p>
					<ig-icon name="chakan" slot="reference"></ig-icon>
				</el-popover> -->
			</el-col>
			<el-col
				:span="4"
				v-if="serviceStatus.znss && secondaryListData.serviceVisitorsToIdentify.visitorNum == null"
				>本月数据：-
			</el-col>

			<el-col :span="4" v-if="serviceStatus.znss">
				<div>开启时间：{{ secondaryListData.serviceVisitorsToIdentify.openDate }}</div>
				<div>
					结束时间：{{ secondaryListData.serviceVisitorsToIdentify.expirationDate }}
					<el-popover
						placement="left"
						width="fit-content"
						trigger="click"
						class=""
						@show="showNumber"
					>
						<div class="month-num-content">
							<div class="month-box">
								<div>日期</div>
								<div v-for="(item, index) in monthList" :key="index">
									<span>{{ item.startDate || '-' }}{{ '至' }}{{ item.endDate || '-' }}</span>
								</div>
							</div>
							<div class="num-box">
								<div>数量</div>
								<div v-for="(item, index) in monthList" :key="item.id">
									<span v-if="!isEdit">{{ item.monthNum }}</span>
									<el-input
										type="number"
										:ref="'month' + index"
										v-if="isEdit"
										v-model="item.monthNum"
										:min="0"
										:disabled="item.isDisabled"
										@blur="blurHandel(item, index)"
									></el-input>
								</div>
							</div>
							<div class="num-box" style="border-left: none">
								<div>月识别</div>
								<div v-for="(item, index) in monthList" :key="index">
									<span>{{ item.visitorNum }}</span>
								</div>
							</div>
						</div>
						<div class="no-data" v-if="monthList.length === 0">暂无数据</div>
						<div class="btn-group" v-if="isEdit">
							<el-button size="small" @click="cancelHandel">取消</el-button>
						</div>
						<div class="btn-group" v-if="!isEdit && monthList.length > 0 && !isAllDisabled">
							<el-button size="small" type="primary" @click="isEditHandel">编辑</el-button>
						</div>

						<ig-icon name="chakan" slot="reference"></ig-icon>
					</el-popover>
				</div>
			</el-col>
			<el-col :span="4"></el-col>
			<el-col :span="4" v-if="serviceStatus.znss">
				<el-button type="text" @click="visitorDialog = true">配置</el-button>
			</el-col>
		</el-row>

		<!-- EDM邮件营销 -->
		<el-row type="flex" class="email-marketing">
			<el-col :span="1">
				<el-tooltip effect="dark" content="服务中" placement="top-start" v-if="serviceStatus.edm">
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">EDM邮件营销</el-col>
			<el-col :span="4"></el-col>
			<el-col :span="4" v-if="serviceStatus.edm"
				>剩余邮件数量：{{ secondaryListData.serviceEdm.edmRemainNum }}</el-col
			>
			<el-col :span="4" v-if="serviceStatus.edm">
				<div>邮件充值总数量：{{ secondaryListData.serviceEdm.edmFunctionNum }}</div>
				<div>邮件消耗总数量：{{ secondaryListData.serviceEdm.edmConsumeNum }}</div>
			</el-col>
			<el-col :span="4"></el-col>
			<!-- <el-col :span="8">绑定发件人邮箱：3</el-col> -->
			<el-col :span="4" v-if="serviceStatus.edm">
				<el-button type="text" @click="edmDialog = true">配置</el-button>
			</el-col>
		</el-row>

		<!-- 云盘 -->
		<el-row type="flex" class="email-marketing">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.cloudDisk"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">云盘</el-col>
			<el-col :span="4"></el-col>
			<el-col :span="4" v-if="serviceStatus.cloudDisk">
				<div>
					云盘剩余容量：{{
						secondaryListData.serviceCloudDisk.functionNum -
						secondaryListData.serviceCloudDisk.useNumConvert
					}}G
				</div>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.cloudDisk">
				<div>云盘总计容量：{{ secondaryListData.serviceCloudDisk.functionNum }}G</div>
				<div>云盘使用容量：{{ secondaryListData.serviceCloudDisk.useNumConvert }}G</div>
			</el-col>
			<el-col :span="4"></el-col>
			<el-col :span="4" v-if="serviceStatus.cloudDisk">
				<el-button type="text" @click="cloudDiskDialog = true">配置</el-button>
			</el-col>
		</el-row>

		<!-- SEO排名监控 -->
		<el-row type="flex" class="email-marketing">
			<el-col :span="1">
				<el-tooltip effect="dark" content="服务中" placement="top-start" v-if="serviceStatus.seo">
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">SEO排名监控</el-col>
			<el-col :span="5" v-if="serviceStatus.seo">
				<div>关键词数量：{{ secondaryListData.serviceSeo.keywordNum }}</div>
				<div>
					扫描国家地区：{{
						`${
							Array.isArray(secondaryListData.serviceSeo.countryNameList)
								? secondaryListData.serviceSeo.countryNameList.join(',')
								: '-'
						}，共计${
							Array.isArray(secondaryListData.serviceSeo.countryNameList)
								? secondaryListData.serviceSeo.countryNameList.length
								: '-'
						}个`
					}}
				</div>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.seo">
				<el-tooltip
					effect="dark"
					placement="top-start"
					:content="
						Array.isArray(secondaryListData.serviceSeo.filterKeywordList)
							? secondaryListData.serviceSeo.filterKeywordList.join(',')
							: '-'
					"
				>
					<div class="uniline">
						过滤关键字列表：{{
							Array.isArray(secondaryListData.serviceSeo.filterKeywordList)
								? secondaryListData.serviceSeo.filterKeywordList.join(',')
								: '-'
						}}
					</div>
				</el-tooltip>

				<div>扫描频次：{{ secondaryListData.serviceSeo.scanFrequencyName }}</div>
			</el-col>
			<el-col :span="3" v-if="serviceStatus.seo">
				<div>扫描页数：{{ secondaryListData.serviceSeo.scanPage }}</div>
				<div>扫描次序：{{ secondaryListData.serviceSeo.scanSourceName }}</div>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.seo">
				<div>关键词消耗时间：{{ secondaryListData.serviceSeo.consumeCycleName }}</div>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.seo">
				<el-button type="text" @click="seoDailog = true">配置</el-button>
				<el-button type="text" @click="serviceEdit('seoRank')">服务编辑</el-button>
			</el-col>
		</el-row>

		<!-- WhatsApp 服务 -->
		<el-row type="flex" class="email-marketing">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.whatsApp"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">WhatsApp服务</el-col>
			<el-col :span="4" v-if="serviceStatus.whatsApp">
				<div>任务：{{ secondaryListData.serviceWhatsApp.flowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('serviceWhatsApp')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.serviceWhatsApp.staffVO &&
								secondaryListData.serviceWhatsApp.staffVO.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.whatsApp">
				<div>WABA账号ID：{{ secondaryListData.serviceWhatsApp.account }}</div>
				<div>手机号：{{ secondaryListData.serviceWhatsApp.mobile }}</div>
			</el-col>
			<el-col :span="4"></el-col>
			<el-col :span="4"></el-col>
			<!-- v-if="serviceStatus.whatsApp" -->
			<el-col :span="4">
				<el-button type="text" @click="serviceEdit('WhatsApp')" v-if="serviceStatus.whatsApp"
					>服务编辑</el-button
				>
			</el-col>
		</el-row>

		<!-- Yandex推广 -->
		<el-row type="flex" class="google">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.yandex"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">Yandex推广</el-col>
			<el-col :span="4" v-if="serviceStatus.yandex">
				<div>任务：{{ secondaryListData.serviceYandex.flowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('serviceYandex')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.serviceYandex.staffVO &&
								secondaryListData.serviceYandex.staffVO.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.yandex"
				>CID：{{ secondaryListData.serviceYandex.cidAccountVal }}</el-col
			>
			<el-col :span="8" v-if="serviceStatus.yandex"> </el-col>
			<el-col :span="4" v-if="serviceStatus.yandex">
				<el-button type="text" @click="serviceEdit('Yandex')">服务编辑</el-button>
			</el-col>
		</el-row>

		<!-- LinkedIn推广 -->
		<el-row type="flex" class="google">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.linkedIn"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">LinkedIn推广</el-col>
			<el-col :span="4" v-if="serviceStatus.linkedIn">
				<div>任务：{{ secondaryListData.serviceLinkedIn.flowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('serviceLinkedIn')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.serviceLinkedIn.staffVO &&
								secondaryListData.serviceLinkedIn.staffVO.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.linkedIn"
				>CID：{{ secondaryListData.serviceLinkedIn.cidAccountVal }}</el-col
			>
			<el-col :span="8" v-if="serviceStatus.linkedIn"> </el-col>
			<el-col :span="4" v-if="serviceStatus.linkedIn">
				<el-button type="text" @click="serviceEdit('LinkedIn')">服务编辑</el-button>
			</el-col>
		</el-row>

		<!-- AI自动回复 -->
		<el-row type="flex" class="google">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.AiReply"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">AI自动回复</el-col>
			<el-col :span="5" v-if="serviceStatus.AiReply">
				<div>BotID: {{ secondaryListData.serviceAiReplyVO.botId || '--' }}</div>
			</el-col>
			<el-col :span="11"> </el-col>
			<el-col :span="4" v-if="serviceStatus.AiReply">
				<el-button type="text" @click="AiReplyDailog = true">配置</el-button>
			</el-col>
		</el-row>

		<!-- 竞争对手分析 -->
		<el-row type="flex" class="google">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.compAnalysis"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">竞争对手分析</el-col>
			<el-col :span="4"></el-col>
			<el-col :span="4" v-if="serviceStatus.compAnalysis">
				<div>竞争对手数量：{{ secondaryListData.competitorAnalysisVO.functionNum }}</div>
				<div>自然关键词数量：{{ secondaryListData.competitorAnalysisVO.keywordNum }}</div>
			</el-col>
			<el-col :span="4" v-if="serviceStatus.compAnalysis">
				<div>反链数量：{{ secondaryListData.competitorAnalysisVO.backlinkNum }}</div>
			</el-col>
			<el-col :span="4"></el-col>
			<el-col :span="4" v-if="serviceStatus.compAnalysis">
				<el-button type="text" @click="compAnalysisDailog = true">配置</el-button>
			</el-col>
		</el-row>

		<!-- AI创作 -->
		<el-row type="flex" class="google">
			<el-col :span="1">
				<el-tooltip
					effect="dark"
					content="服务中"
					placement="top-start"
					v-if="serviceStatus.aiCreative"
				>
					<div class="serivice-ing"></div>
				</el-tooltip>
				<el-tooltip effect="dark" content="无服务" placement="top-start" v-else>
					<div class="no-serivice"></div>
				</el-tooltip>
			</el-col>
			<el-col :span="3" class="title">AI创作</el-col>
			<el-col :span="4"></el-col>
			<el-col :span="8" v-if="serviceStatus.aiCreative">
				<div>文章数量：{{ secondaryListData.serviceAiCreativeVO.functionNum }}</div>
			</el-col>
			<el-col :span="4"></el-col>
			<el-col :span="4" v-if="serviceStatus.aiCreative">
				<el-button type="text" @click="aiCreativeDailog = true">配置</el-button>
			</el-col>
		</el-row>

		<!-- 社媒管理 -->
		<!-- <el-row type="flex" class="socialMedia" v-if="typeLists.media">
			<el-col :span="3" class="title">{{ '社媒管理' }}</el-col>
			<el-col :span="4">
				<div>任务：{{ secondaryListData.mediaFlowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('socialServiceStaff')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.socialServiceStaff &&
								secondaryListData.socialServiceStaff.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>
			<el-col :span="12">
				<div class="platform" v-for="item in secondaryListData.platformList" :key="item.pageId">
					<el-col class="platform-item" :span="8">平台：{{ platform(item.businessCode) }}</el-col>
					<el-tooltip
						effect="dark"
						:content="item.pageName"
						placement="top-start"
						:disabled="!item.pageName"
					>
						<el-col class="platform-item home-page uniline" :span="8"
							>主页地址：{{ item.pageName }}</el-col
						>
					</el-tooltip>
					<el-col class="platform-item" :span="8">绑定时间：{{ item.formatBindingTime }}</el-col>
				</div>
			</el-col>
			<el-col :span="4">
				<el-button type="text" @click="serviceEdit('Media')">服务编辑</el-button>
			</el-col>
		</el-row> -->

		<!-- 视频拍摄 -->
		<!-- <el-row type="flex" class="video" v-if="typeLists.video">
			<el-col :span="4" class="title">{{ '视频拍摄' }}</el-col>
			<el-col :span="4">
				<div>任务：{{ secondaryListData.videoFlowName }}</div>
				<el-popover placement="top" width="400" trigger="hover">
					<serviceInfo :tableData="setServiceInfo('videoServiceStaff')"></serviceInfo>
					<div slot="reference">
						服务人员：{{
							(secondaryListData.videoServiceStaff &&
								secondaryListData.videoServiceStaff.username) ||
							'-'
						}}
					</div>
				</el-popover>
			</el-col>
			<el-col :span="4">拍摄个数：{{ secondaryListData.number }}个</el-col>
			<el-col :span="8">拍摄时长：{{ secondaryListData.mins }}min</el-col>
			<el-col :span="4">
				<el-button type="text" @click="serviceEdit('Video')">服务编辑</el-button>
			</el-col>
		</el-row> -->

		<!-- 服务编辑 -->
		<dialog-form
			:dialogVisible="showDialog"
			:attributes="attributes"
			:formData="orderGroups"
			@close:dialogVisible="val => (showDialog = val)"
			@confirm="confirm"
		></dialog-form>
		<!-- 系统配置 -->
		<dialog-form
			:dialogVisible="systemDialog"
			:attributes="attributes"
			:formData="systemGroups"
			@close:dialogVisible="val => (systemDialog = val)"
			@confirm="systemConfirm"
		></dialog-form>
		<!-- 网建配置 -->
		<dialog-form
			:dialogVisible="webDialog"
			:attributes="attributes"
			:formData="webGroups"
			@close:dialogVisible="val => (webDialog = val)"
			@confirm="webConfirm"
		></dialog-form>
		<!-- 邮件营销配置 -->
		<dialog-form
			:dialogVisible="edmDialog"
			:attributes="attributes"
			:formData="edmGroups"
			@close:dialogVisible="val => (edmDialog = val)"
			@confirm="edmConfirm"
		></dialog-form>
		<!-- 网站访客智能识别配置 -->
		<dialog-form
			:dialogVisible="visitorDialog"
			:attributes="attributes"
			:formData="visitorGroups"
			@close:dialogVisible="val => (visitorDialog = val)"
			@confirm="visitorConfirm"
		></dialog-form>

		<!-- 云盘配置 -->
		<dialog-form
			:dialogVisible="cloudDiskDialog"
			:attributes="attributes"
			:formData="cloudDiskGroups"
			@close:dialogVisible="val => (cloudDiskDialog = val)"
			@confirm="cloudDiskConfirm"
		></dialog-form>

		<!-- SEO排名监控 -->
		<dialog-form
			:dialogVisible="seoDailog"
			:attributes="{
				title: '配置',
				width: '600px',
				labelWidth: '160px',
			}"
			:formData="seoGroups"
			@close:dialogVisible="val => (seoDailog = val)"
			@confirm="seoConfirm"
		></dialog-form>

		<!-- AI自动回复配置 -->
		<dialog-form
			:dialogVisible="AiReplyDailog"
			:attributes="attributes"
			:formData="AiReplyGroups"
			@close:dialogVisible="val => (AiReplyDailog = val)"
			@confirm="AiReplyConfirm"
		></dialog-form>

		<!-- 竞争对手分析配置 -->
		<dialog-form
			:dialogVisible="compAnalysisDailog"
			:attributes="attributes"
			:formData="compAnalysisGroup"
			@close:dialogVisible="val => (compAnalysisDailog = val)"
			@confirm="compAnalysisConfirm"
		></dialog-form>

		<!-- AI创作配置 -->
		<dialog-form
			:dialogVisible="aiCreativeDailog"
			:attributes="attributes"
			:formData="aiCreativeGroup"
			@close:dialogVisible="val => (aiCreativeDailog = val)"
			@confirm="aiCreativeConfirm"
		></dialog-form>

		<!-- Whatspp 弹框 -->
		<whatsappDialogFrom
			:dialogVisible="whatsAppDialog"
			:attributes="attributes"
			:formData="whatsAppFromData"
			@close:dialogVisible="val => (whatsAppDialog = val)"
			@confirm="confirm"
			@launchWhatsAppSignup="launchWhatsAppSignup"
			@bindPhoneNumber="bindPhoneNumber"
		>
		</whatsappDialogFrom>
	</div>
</template>

<script>
import serviceListConfig from '@/components/customer/serviceListConfig.js';
import dialogForm from '@/components/dialogForm/dialogForm.vue';
import skyProgress from '@/components/iglobalwin/formComponents/sky-progress.vue';
import ordersGroups from '@/components/customer/ordersGroups.js';
import industry from '@/components/customer/industry';
import platform from '@/components/iglobalwin/formComponents/account/sky-media';
import { validRequired, validNum } from '@/common/elementValid.js';
import { getTaskFlowList } from '@/backend/services/task/task';
import customer from '@/backend/services/account/customer.js';
import serviceInfo from '@/components/customer/serviceInfo.vue';
import _ from 'lodash';
import moment from 'dayjs';
import whatsappDialogFrom from './whatsappDialogFromWABA.vue';
import popoverText from '@/components/tools/popoverText.vue';

import {
	mediaPlatForm,
	serviceList,
	terminalList,
	lang,
	domainType,
	serviceLocate,
	isTransfer,
	// sitePlatform,
	companyEmail,
} from '@/common/dictionary';
import serApi from '@/backend/services/account/service.js';
export default {
	props: ['scope', 'tableData'],
	data() {
		return {
			configData: {},
			showDialog: false,
			orderGroups: {},
			systemDialog: false,
			systemGroups: {},
			webDialog: false,
			webGroups: {},
			edmDialog: false,
			edmGroups: {},
			visitorGroups: {},
			visitorDialog: false,
			cloudDiskGroups: {},
			cloudDiskDialog: false,
			seoDailog: false,
			AiReplyGroups: {},
			AiReplyDailog: false,
			compAnalysisGroup: {},
			compAnalysisDailog: false,
			aiCreativeGroup: {},
			aiCreativeDailog: false,
			seoGroups: {},
			attributes: {
				title: '配置',
				labelWidth: '180px',
			},
			serviceName: '',
			visible: false,
			visitorList: [],
			userList: [],
			monthList: [],
			clonemonthList: [],
			isEdit: false,
			isAllDisabled: false,
			whatsAppDialog: false,
			whatsAppFromData: {},
			whatsAppObj: {},
		};
	},
	computed: {
		secondaryListData() {
			let { scope } = this;
			if (!(scope && scope.row)) return false;
			let particularVal = {
				expirationRate: true,
				expirationTime: true,
				haveSystemFunctionNum: true,
				systemFunctionNum: true,
				renewalChainRatio: true,
				number: true,
				mins: true,
			};
			Object.keys(scope.row).forEach(key => {
				// 空值处理
				if (
					(typeof scope.row[key] !== 'object' || scope.row[key] === null) &&
					!particularVal[key]
				) {
					if (!scope.row[key] && scope.row[key] !== 0) scope.row[key] = '-';
				}
				if (particularVal[key]) {
					if (!scope.row[key]) scope.row[key] = 0;
				}
				if (key === 'formatExpirationTime' && scope.row[key] === '-') {
					scope.row[key] = null;
				}
				if (key === 'tgDomain' && scope.row[key] === '-') {
					scope.row[key] = null;
				}
			});
			return this.scope && this.scope.row;
		},
		languageOnline() {
			let { languageList, functionNum } = this.secondaryListData.serviceSite;
			if (languageList && functionNum) {
				let childLength = languageList.filter(item => item.status == 6).length;
				return `${childLength}/${functionNum}`;
			} else {
				return '0/0';
			}
		},
		homePageName() {
			if (this.secondaryListData && this.secondaryListData.platformList) {
				let activeList = this.secondaryListData.platformList.filter(item => item.businessCode);
				return (activeList[0] && activeList[0].pageName) || '-';
			} else {
				return '';
			}
		},
		typeLists() {
			let { typeList } = this.secondaryListData;

			return {
				system: typeList && typeList.indexOf(0) !== -1,
				site: typeList && typeList.indexOf(1) !== -1,
				media: typeList && typeList.indexOf(2) !== -1,
				google: typeList && typeList.indexOf(3) !== -1,
				video: typeList && typeList.indexOf(4) !== -1,
				operations: typeList && typeList.indexOf(6) !== -1,
				facebook: typeList && typeList.indexOf(7) !== -1,
				edm: typeList && typeList.indexOf(11) !== -1,
				znss: typeList && typeList.indexOf(10) !== -1,
				cloudDisk: typeList && typeList.indexOf(14) !== -1,
			};
		},
		pageId() {
			if (this.secondaryListData && this.secondaryListData.platformList) {
				var arr = this.secondaryListData.platformList.filter(item => item.businessCode === '26');
			}
			if (arr.length === 0) return '-';
			return arr[0].pageId;
		},
		// 各个服务的状态
		serviceStatus() {
			let {
				serviceEdm,
				serviceFacebook,
				serviceGoogle,
				serviceSeo,
				serviceSite,
				serviceSns,
				serviceVisitorsToIdentify,
				serviceCloudDisk,
				serviceWhatsApp,
				serviceYandex,
				serviceLinkedIn,
				serviceAiReplyVO,
				competitorAnalysisVO,
				serviceAiCreativeVO,
			} = this.secondaryListData;

			return {
				site: serviceSite !== '-' ? true : false,
				google: serviceGoogle !== '-' ? true : false,
				facebook: serviceFacebook !== '-' ? true : false,
				edm: serviceEdm !== '-' ? true : false,
				operations: serviceSns !== '-' ? true : false,
				znss: serviceVisitorsToIdentify !== '-' ? true : false,
				seo: serviceSeo !== '-' ? true : false,
				cloudDisk: serviceCloudDisk !== '-' ? true : false,
				whatsApp: serviceWhatsApp !== '-' ? true : false,
				yandex: serviceYandex !== '-' ? true : false,
				linkedIn: serviceLinkedIn !== '-' ? true : false,
				AiReply: serviceAiReplyVO !== '-' ? true : false,
				compAnalysis: competitorAnalysisVO !== '-' ? true : false,
				aiCreative: serviceAiCreativeVO !== '-' ? true : false,
			};
		},
		showStartServiceButton() {
			return this.getPermission(this.$permissionData.startService.englishName);
		},
	},
	mounted() {
		this.setConfigData();
	},
	watch: {
		// 监听对象的变化   及时更新配置里的数值的回显
		secondaryListData: {
			handler: function () {
				this.setConfigData();
			},
			deep: true, //深度侦听
			immediate: true, //立即执行(页面刚进来也会执行)
		},
		whatsAppDialog: {
			handler: function (val) {
				if (val) {
					window.addEventListener('message', this.sessionInfoListener);
				} else {
					window.removeEventListener('message', this.sessionInfoListener);
				}
			},
			deep: true, //深度侦听
			immediate: true, //立即执行(页面刚进来也会执行)
		},
	},
	methods: {
		async setConfigData() {
			let { scope, secondaryListData } = this;
			if (scope && scope.row) {
				this.configData = serviceListConfig(scope.row);
			}
			this.systemGroups = {
				date: {
					label: '到期时间',
					formType: 'sky-date-picker',
					type: 'date',
					format: 'yyyy-MM-dd',
					'value-format': 'yyyy-MM-dd',
					value: secondaryListData.formatExpirationTime,
					rules: [validRequired('此项必填', 'change')],
				},
				systemFunctionNum: {
					label: '系统账号',
					formType: 'sky-input',
					inputType: 'number',
					value: secondaryListData.systemFunctionNum,
					rules: [validRequired('此项必填')],
				},
				tgDomain: {
					label: '推广域名',
					formType: 'sky-input',
					inputType: 'text',
					value: secondaryListData.tgDomain,
				},
			};
			this.webGroups = {
				language: {
					label: '语种数量',
					formType: 'sky-input',
					inputType: 'number',
					value: secondaryListData.serviceSite.functionNum,
					rules: [validRequired('此项必填')],
				},
				// sitePlatform: {
				// 	label: '建站平台',
				// 	formType: 'sky-select',
				// 	options: sitePlatform.slice(1),
				// 	value: secondaryListData.sitePlatform || "",
				// 	rules: [validRequired('此项必填', 'change')],
				// },
			};
			this.visitorGroups = {
				systemFunctionNum: {
					label: '单月最大数量',
					formType: 'sky-input',
					inputType: 'number',
					value: secondaryListData.serviceVisitorsToIdentify.monthNum,
					rules: [validRequired('此项必填')],
				},
				date: {
					label: '结束时间',
					formType: 'sky-date-picker',
					type: 'date',
					format: 'yyyy-MM-dd',
					'value-format': 'yyyy-MM-dd',
					value:
						secondaryListData.serviceVisitorsToIdentify.expirationDate === '-'
							? null
							: secondaryListData.serviceVisitorsToIdentify.expirationDate,
					rules: [validRequired('此项必填', 'change')],
				},
			};
			this.edmGroups = {
				functionNum: {
					label: '邮件充值总数量',
					formType: 'sky-input',
					inputType: 'number',
					value: secondaryListData.serviceEdm.edmFunctionNum,
					rules: [validRequired('此项必填')],
				},
			};
			this.cloudDiskGroups = {
				functionNum: {
					label: '云盘容量',
					formType: 'sky-input',
					inputType: 'number',
					value: secondaryListData.serviceCloudDisk.functionNum,
					rules: [validRequired('此项必填')],
				},
			};
			this.AiReplyGroups = {
				botId: {
					label: 'botId',
					formType: 'sky-input',
					value: secondaryListData.serviceAiReplyVO.botId,
					rules: [validRequired('此项必填')],
				},
			};
			this.compAnalysisGroup = {
				functionNum: {
					label: '竞争对手数量',
					formType: 'sky-input',
					inputType: 'number',
					min: 0,
					value: secondaryListData.competitorAnalysisVO.functionNum,
					rules: [validRequired('此项必填')],
				},
				keywordNum: {
					label: '自然关键词数量',
					formType: 'sky-input',
					inputType: 'number',
					min: 0,
					value: secondaryListData.competitorAnalysisVO.keywordNum,
					rules: [validRequired('此项必填')],
				},
				backlinkNum: {
					label: '反链数量',
					formType: 'sky-input',
					inputType: 'number',
					min: 0,
					value: secondaryListData.competitorAnalysisVO.backlinkNum,
					rules: [validRequired('此项必填')],
				},
			};
			this.aiCreativeGroup = {
				functionNum: {
					label: '文章数量',
					formType: 'sky-input',
					inputType: 'number',
					min: 0,
					value: secondaryListData.serviceAiCreativeVO.functionNum,
					rules: [validRequired('此项必填')],
				},
			};
			let { serviceSeo } = secondaryListData;
			this.seoGroups = {
				keywordNum: {
					label: '关键词数量',
					formType: 'sky-input',
					inputType: 'number',
					min: 0,
					value: serviceSeo.keywordNum || '',
					rules: [validRequired('此项必填')],
				},
			};
		},
		//获取访客每月识别数
		async getMonthdistinguishnum(id) {
			let res = await customer.monthdistinguishnum({ id: id });
			this.visitorList = res.data;
		},
		// 获取任务流
		getTaskFlowList(type) {
			return () => {
				return getTaskFlowList({
					type,
				});
			};
		},
		show() {
			this.getMonthdistinguishnum(this.secondaryListData.id);
		},
		// 服务编辑
		async serviceEdit(serviceName) {
			let { getTaskFlowList, secondaryListData } = this;
			this.serviceName = serviceName;
			let obj = {};
			if (serviceName == 'seoRank') {
				let res = await customer.getServiceSeoDetail(secondaryListData.id);
				obj = res.data;
			} else {
				let res = await customer.servicedetail(secondaryListData.id);
				obj = res.data[`service${serviceName}`] || {};
			}
			if (serviceName == 'WhatsApp') {
				this.whatsAppObj = obj;
				this.whatsAppFromData = {
					WhatsApp: {
						label: '',
						data: 'WhatsApp服务',
						formType: 'sky-line',
					},
					flowId: {
						label: 'WhatsApp任务流',
						formType: 'sky-select',
						options: getTaskFlowList(21),
						props: {
							label: 'name',
							value: 'id',
						},
						value: obj.flowId,
						rules: [validRequired('此项必填', 'change')],
					},
					account: {
						label: 'WABA账号ID',
						formType: 'sky-input-button',
						value: obj.account || '',
						rules: [validRequired('此项必填'), validNum()],
					},
					mobile: {
						label: ' 手机号',
						formType: 'sky-input',
						value: obj.mobile || '',
						rules: [validRequired('此项必填')],
						// type: 'phone'
					},
				};
				this.whatsAppDialog = true;
			} else {
				const that = this;
				that.orderGroups = ordersGroups({
					obj,
					validRequired,
					validNum,
					serviceName,
					options: {
						serviceList,
						terminalList,
						getTaskFlowList,
						lang,
						domainType,
						isTransfer,
						serviceLocate,
						mediaPlatForm,
						// sitePlatform,
						companyEmail,
					},
					type: {
						industry,
						platform,
					},
					// userList
				});
				this.showDialog = true;
			}
		},
		// 服务编辑-确认
		async confirm(cb) {
			let that = this;
			let { orderGroups, secondaryListData, serviceName, whatsAppFromData, whatsAppObj } = this;
			if (serviceName == 'WhatsApp') {
				var serviceWhatsApp = {
					account: whatsAppFromData.account.value,
					flowId: whatsAppFromData.flowId.value,
					mobile: whatsAppFromData.mobile.value,
				};
			} else {
				var serviceFacebook = {
					flowId: orderGroups.FBFlowId.value,
					cidAccountVal: orderGroups.FBID.value,
				};
				var serviceGoogle = {
					flowId: orderGroups.googleFlowId.value,
					cidAccountVal: orderGroups.cid.value,
					flagLanguageReport: orderGroups.flagLanguageReport.value,
					languageList: orderGroups.googleLanguageList.value,
					languageServiceStaffId: orderGroups.languageServiceStaffId.value,
					languageServiceStaffName: orderGroups.languageServiceStaffName.value,
				};
				var serviceMedia = {
					flowId: orderGroups.mediafaxFlowId.value,
					platformList: orderGroups.platformList.value,
				};
				var serviceMediaOperation = {
					// operationFlowId: orderGroups.mediafaxFlowId1.value,
					// platformList: orderGroups.platformLists.value,
					subject: orderGroups.subject.value,
					taskCount: orderGroups.taskCount.value,
				};
				var serviceSite = {
					domain: orderGroups.domain.value,
					domainService: orderGroups.domainService.value,
					domainTransfer: orderGroups.domainTransfer.value,
					flowId: orderGroups.siteFlowId.value,
					languageDefault: orderGroups.languageDefault.value,
					languageList: orderGroups.languageList.value,
					primaryIndustry: orderGroups.industryType.value[0],
					secondIndustry: orderGroups.industryType.value[1],
					qyEmailType: orderGroups.qyEmailType.value,
					referDesign: orderGroups.referDesign.value,
					// sitePlatform: orderGroups.sitePlatform.value,
					siteType: orderGroups.siteType.value,
					spaceService: orderGroups.spaceService.value,
				};
				var serviceVideo = {
					flagSubtitle: orderGroups.flagSubtitle.value,
					flagUploadYoutube: orderGroups.flagUploadYoutube.value,
					flowId: orderGroups.videoFlowId.value,
					mins: orderGroups.mins.value,
					number: orderGroups.number.value,
				};

				var serviceYandex = {
					flowId: orderGroups.yandexFlowId.value,
					cidAccountVal: orderGroups.yandexCidAccountVal.value,
				};
				var serviceLinkedIn = {
					flowId: orderGroups.linkedInFlowId.value,
					cidAccountVal: orderGroups.linkedInCidAccountVal.value,
				};
			}

			let params = {};

			if (serviceName == 'seoRank') {
				params = {
					id: secondaryListData.id,
					consumeCycle: orderGroups.consumeCycle.value,
					countryIdList: orderGroups.countryIdList.value,
					scanFrequency: orderGroups.scanFrequency.value,
					scanPage: orderGroups.scanPage.value,
					scanSource: orderGroups.scanSource.value,
					filterKeywordList: orderGroups.filterKeywordList.value.split(','),
				};
				try {
					await customer.setServiceSeo(params);
					that.tableData.refreshData();
					that.$message.success('编辑成功');
					cb();
				} catch (error) {
					that.$message.info('编辑失败');
					cb(false);
				}
				return;
			}
			if (serviceName == 'WhatsApp') {
				try {
					let bindParams = {
						phoneNumber: whatsAppFromData.mobile.value,
						wabaId: whatsAppObj.waba_id || whatsAppFromData.account.value,
						serviceSiteId: secondaryListData.id,
					};
					let bindRes = await serApi.bindPhone(bindParams);
					if (bindRes.data == 1) {
						let whatsAppParams = {
							id: secondaryListData.id,
							serviceWhatsApp,
						};

						let res = await customer.serviceEdit(whatsAppParams);
						if (res.status === 204) {
							this.tableData.refreshData();
							this.$message.success('编辑成功');
							cb();
						}
					}
				} catch (error) {
					that.$message.info('编辑失败');
					cb(false);
					console.log(error);
				}

				return;
			}

			switch (serviceName) {
				case 'Facebook':
					params = {
						id: secondaryListData.id,
						serviceFacebook,
					};
					break;
				case 'Google':
					params = {
						id: secondaryListData.id,
						serviceGoogle,
					};
					break;
				case 'Media':
					params = {
						id: secondaryListData.id,
						serviceMedia,
					};
					break;
				case 'MediaOperation':
					params = {
						id: secondaryListData.id,
						serviceMediaOperation,
					};
					break;
				case 'Site':
					params = {
						id: secondaryListData.id,
						serviceSite,
					};
					break;
				case 'Video':
					params = {
						id: secondaryListData.id,
						serviceVideo,
					};
					break;
				case 'Yandex':
					params = {
						id: secondaryListData.id,
						serviceYandex,
					};
					break;
				case 'LinkedIn':
					params = {
						id: secondaryListData.id,
						serviceLinkedIn,
					};
					break;
			}
			try {
				let res = await customer.serviceEdit(params);
				if (res.status === 204) {
					that.tableData.refreshData();
					that.$message.success('编辑成功');
					cb();
				}
			} catch (error) {
				that.$message.info('编辑失败');
				cb(false);
				console.log(error);
			}
		},
		// 平台映射
		platform(type) {
			switch (type) {
				case '25':
					return 'LinkedIn';
				case '26':
					return 'Facebook';
				case '27':
					return 'Twitter';
				case '29':
					return 'TikTok';
				default:
					return '-';
			}
		},
		// 邮箱类型映射
		emailType(type) {
			switch (type) {
				case 1:
					return '新版企业邮箱';
				case 2:
					return '旧版企业邮箱';
				case 3:
					return '不使用';
				case 4:
					return '新版邮箱列表';
				default:
					return '-';
			}
		},
		// 监测类型映射
		accessType(type) {
			switch (type) {
				case 1:
					return 'Google';
				case 2:
					return '百度';
				case 3:
					return 'SkyMonitor';
				default:
					return '-';
			}
		},
		systemConfirm(cb) {
			let { systemGroups, tableData, scope } = this;
			let valArr = Object.keys(systemGroups).map(key => systemGroups[key].value);
			tableData.getCode(valArr, 'system', scope.row && scope.row.id);
			cb();
		},
		webConfirm(cb) {
			let { webGroups, tableData, scope } = this;
			let valArr = Object.keys(webGroups).map(key => webGroups[key].value);
			tableData.getCode(valArr, 'website', scope.row && scope.row.id);
			cb();
		},
		async edmConfirm(cb) {
			let { edmGroups, tableData, scope } = this;
			let valArr = Object.keys(edmGroups).map(key => edmGroups[key].value);
			let params = {
				edmNum: valArr[0],
				serviceId: this.secondaryListData.id,
			};
			let res = await serApi.edmCupyNumcheck(params);
			if (+valArr[0] < res.data) {
				this.$message.warning('总数小于已分配数量，请提醒客户修改');
				cb(false);
				return;
			}
			tableData.getCode(valArr, 'edm', scope.row && scope.row.id);
			cb();
		},
		visitorConfirm(cb) {
			let { visitorGroups, tableData, scope } = this;
			let valArr = Object.keys(visitorGroups).map(key => visitorGroups[key].value);
			tableData.getCode(valArr, 'visitor', scope.row && scope.row.id);
			cb();
		},
		cloudDiskConfirm(cb) {
			let { cloudDiskGroups, tableData, scope } = this;
			let valArr = Object.keys(cloudDiskGroups).map(key => cloudDiskGroups[key].value);
			tableData.getCode(valArr, 'cloudDisk', scope.row && scope.row.id);
			cb();
		},
		// AI自动回复配置弹框确定
		AiReplyConfirm(cb) {
			let { AiReplyGroups, tableData, scope } = this;
			let valArr = Object.keys(AiReplyGroups).map(key => AiReplyGroups[key].value);
			tableData.getCode(valArr, 'AiReply', scope.row && scope.row.id);
			cb();
		},
		// 竞争对手分析配置弹框确定
		compAnalysisConfirm(cb) {
			let { compAnalysisGroup, tableData, scope } = this;
			let valArr = Object.keys(compAnalysisGroup).map(key => compAnalysisGroup[key].value);
			tableData.getCode(valArr, 'compAnalysis', scope.row && scope.row.id);
			cb();
		},
		//ai创作配置弹框确定
		aiCreativeConfirm(cb) {
			let { aiCreativeGroup, tableData, scope } = this;
			let valArr = Object.keys(aiCreativeGroup).map(key => aiCreativeGroup[key].value);
			tableData.getCode(valArr, 'aiCreative', scope.row && scope.row.id);
			cb();
		},
		// seo排名监控配置弹框确定
		seoConfirm(cb) {
			let { seoGroups, tableData, scope } = this;
			let valArr = Object.keys(seoGroups).map(key => seoGroups[key].value);
			tableData.getCode(valArr, 'seoRank', scope.row && scope.row.id);
			cb();
		},
		setServiceInfo(val) {
			let data = this.secondaryListData[val].staffVO || {};
			return {
				dataStyle() {
					return {
						name: data.username || '-',
						corp: data.companyName || '-',
						deptName: data.deptName || '-',
						mobile: data.phone || '-',
						email: data.email || '-',
					};
				},
			};
		},
		// 点击月份数量的编辑icon
		isEditHandel() {
			this.isEdit = true;
			let canEdit = [];
			this.monthList.map((item, index) => {
				if (!item.isDisabled) {
					canEdit.push(index);
				}
			});
			let domMonth = 'month' + canEdit[0];
			this.$nextTick(() => {
				this.$refs['month' + canEdit[0]][0].focus();
			});
		},
		// 点击取消
		cancelHandel() {
			this.isEdit = false;
		},
		async showNumber() {
			let params = {
				type: 10,
				serviceId: this.secondaryListData.id,
			};
			let res = await customer.getRemainList(params);
			this.monthList = res.data;
			this.monthList.forEach(item => {
				if (
					moment(item.endDate).format('YYYYMMDD') < moment().format('YYYYMMDD') ||
					!item.endDate
				) {
					item.isDisabled = true;
				} else {
					item.isDisabled = false;
				}
			});
			let isAllDisabledList = this.monthList.filter(item => {
				return !item.isDisabled;
			});
			isAllDisabledList.length == 0 ? (this.isAllDisabled = true) : (this.isAllDisabled = false);

			this.clonemonthList = _.cloneDeep(this.monthList);
		},
		async blurHandel(item, index) {
			let { tableData } = this;
			// editRemain
			if (item.monthNum == this.clonemonthList[index].monthNum) {
				return;
			}
			let valArr = item.monthNum;
			tableData.getCode(valArr, 'editMonthRemain', item && item.id);
		},
		launchWhatsAppSignup() {
			// Facebook Login with JavaScript SDK
			// Conversion tracking code
			window.fbq &&
				window.fbq('trackCustom', 'WhatsAppOnboardingStart', {
					appId: '1399631517488334',
					feature: 'whatsapp_embedded_signup',
				});
			// // Launch Facebook login
			window.FB.login(
				response => {
					console.log(response);
					if (response.authResponse) {
						const code = response.authResponse.code;
						// The returned code must be transmitted to your backend,
						// which will perform a server-to-server call from there to our servers for an access token
					} else {
						console.log('User cancelled login or did not fully authorize.');
					}
				},
				{
					scope: 'whatsapp_business_management',
					extras: {
						feature: 'whatsapp_embedded_signup',
						setup: {
							// ... // Prefilled data can go here
						},
						sessionInfoVersion: 2,
					},
				}
			);
		},
		async sessionInfoListener(event) {
			let whatsAppOptions = this.getTaskFlowList(12);
			if (event.origin !== 'https://www.facebook.com') return;
			try {
				const data = JSON.parse(event.data);
				if (data.type === 'WA_EMBEDDED_SIGNUP') {
					// if user finishes the Embedded Signup flow
					if (data.event === 'FINISH') {
						const { waba_id, phone_number_id } = data.data;
						this.whatsAppObj.account = waba_id;
						this.whatsAppObj.phoneId = phone_number_id;
						this.whatsAppObj.mobile = '';
						this.whatsAppFromData = {
							WhatsApp: {
								label: '',
								data: 'WhatsApp服务',
								formType: 'sky-line',
							},
							flowId: {
								label: 'WhatsApp任务流',
								formType: 'sky-select',
								options: whatsAppOptions,
								props: {
									label: 'name',
									value: 'id',
								},
								value: this.whatsAppObj.flowId,
								rules: [validRequired('此项必填', 'change')],
							},
							account: {
								label: 'WABA账号ID',
								formType: 'sky-input-button',
								value: this.whatsAppObj.account || '',
								rules: [validRequired('此项必填'), validNum()],
							},
							mobile: {
								label: '手机号',
								formType: 'sky-input',
								value: this.whatsAppObj.mobile || '',
								rules: [validRequired('此项必填')],
							},
						};
						let params = {
							serviceSiteId: this.secondaryListData.id,
							data: JSON.stringify(data),
						};
						console.log(params);
						await serApi.fillbindinfo(params);
					}
					// if user cancels the Embedded Signup flow
					else {
						const { current_step } = data.data;
					}
				}
			} catch {
				// Don’t parse info that’s not a JSON
				console.log('Non JSON Response', event.data);
			}
		},
		async bindPhoneNumber(reset) {
			if (!this.whatsAppFromData.mobile.value) {
				this.$message.warning('请输入手机号');
				return;
			}
			// if(!this.whatsAppObj.waba_id) {
			// 	this.$message.warning('请先去创建WABA')
			// 	return
			// }
			try {
				let params = {
					phoneNumber: this.whatsAppFromData.mobile.value,
					phoneNumberId: this.whatsAppObj.phoneId,
					wabaId: this.whatsAppObj.waba_id || this.whatsAppFromData.account.value,
					serviceSiteId: this.secondaryListData.id,
				};
				console.log(params);
				await serApi.bindPhone(params);
				this.$message.success('绑定成功');
				reset();
			} catch (error) {
				this.$message.error('绑定失败，请重试');
				reset();
			}
		},
		// 开始服务
		startService() {
			this.$confirm('确认服务后，套餐开始计算服务周期，请与客户确认服务开始后谨慎操作。', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'none',
			}).then(async () => {
				let params = {
					id: this.secondaryListData.id,
				};
				await serApi.startService(params);
				this.tableData.refreshData();
			});
		},
	},
	components: { skyProgress, dialogForm, serviceInfo, whatsappDialogFrom, popoverText },
};
</script>

<style lang="scss" scoped>
.icon-chakan {
	font-size: 12px;
}

.monthNum {
	display: flex;
	justify-content: space-between;
}

.service-function-list {
	width: 100%;
	font-size: 14px;
	text-align: left;

	.el-row {
		justify-content: start;
		align-items: center;
		border-bottom: 1px solid #e3e3e3;
		min-height: 52px;

		.el-col {
			height: 100%;
			padding: 4px 10px;

			div {
				padding: 3px 0;
			}

			&:last-child {
				// text-align: center;
			}

			&.title {
				font-weight: bold;
			}
			// 语种
			.language {
				.language-item {
					margin: 3px;
				}
			}
			// 平台
			.platform {
				height: 100%;

				.platform-item {
					height: 100%;
					padding: 4px 5px;
					text-align: left;
				}
			}

			.uniline {
				// 单行溢出
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.home-page {
				color: #409eff;
				cursor: pointer;
				user-select: none;
			}
		}
	}
}
.btn-group {
	text-align: right;
	margin-top: 20px;
	padding-right: 30px;
	margin-bottom: 20px;
}
.month-num-content {
	padding-right: 30px;
	position: relative;
	margin: 30px;
	display: flex;
}
.edit-icon {
	position: absolute;
	right: -5px;
	top: 20px;
	cursor: pointer;
	font-size: 20px;
}
.serivice-ing {
	width: 15px;
	height: 15px;
	border-radius: 50%;
	background-color: #67c23a;
}
.no-serivice {
	width: 15px;
	height: 15px;
	border-radius: 50%;
	background-color: #d1d1d1;
}
.month-box,
.num-box {
	border: 1px solid #e3e3e3;
	width: fit-content;
	> div {
		border-top: 1px solid #e3e3e3;
		padding: 5px 0;
		width: 200px;
		text-align: center;
		&:last-child {
			border-right: none;
		}
	}
	::v-deep .el-input {
		height: 100%;
	}
	::v-deep .el-input__inner {
		height: 100%;
		border: none;
		text-align: center;
	}
	::v-deep .el-input.is-disabled .el-input__inner {
		background-color: transparent;
		color: #606266;
	}
}
.num-box {
	border-top: none;
	> div {
		width: 100px;
		height: 30.59px;
	}
}
.month-box {
	border-right: none;
	border-top: none;
}
.no-data {
	text-align: center;
	margin-bottom: 30px;
}
</style>
